(() => {
  if (window.scentalyaCartCounter) return;
  const originalFetch = window.fetch;
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;
  let revision = 0;
  let pending = 0;
  let timer;
  let lastCount;
  let announceAdd = false;
  let popupTimer;
  const animations = new WeakMap();

  function bounce() {
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.cart-count').forEach((element) => {
      if (typeof element.animate !== 'function') return;
      animations.get(element)?.cancel();
      animations.set(element, element.animate([
        { translate: '0 0', scale: '1' },
        { translate: '0 -4px', scale: '1.12', offset: 0.35 },
        { translate: '0 1px', scale: '0.98', offset: 0.7 },
        { translate: '0 0', scale: '1' }
      ], { duration: 420, easing: 'ease-out' }));
    });
  }

  function isCartMutation(input) {
    try {
      const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href);
      return url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(url.pathname);
    } catch {
      return false;
    }
  }

  function ensureBadges() {
    document.querySelectorAll('#header a[href], #header-phone a[href], #phone-cart a[href]').forEach((link) => {
      try {
        const url = new URL(link.href, location.href);
        if (url.origin !== location.origin || !/\/cart\/?$/.test(url.pathname)) return;
        if (!link.querySelector('.cart-count')) {
          const badge = document.createElement('span');
          badge.className = 'cart-count';
          badge.hidden = true;
          link.appendChild(badge);
        }
        link.style.position = 'relative';
      } catch {}
    });
  }

  function positionProgress() {
    const popup = document.getElementById('sca-cart-mini-progress');
    if (!popup || popup.hidden) return;
    const links = [...document.querySelectorAll('#header a[href], #header-phone a[href], #phone-cart a[href]')];
    const anchor = links.find((link) => {
      try { return /\/cart\/?$/.test(new URL(link.href, location.href).pathname) && link.getClientRects().length && link.getBoundingClientRect().width > 0; } catch { return false; }
    });
    const rect = anchor?.getBoundingClientRect();
    const width = popup.getBoundingClientRect().width || Math.min(360, window.innerWidth - 32);
    popup.style.right = 'auto';
    popup.style.left = `${Math.max(16, Math.min(window.innerWidth - width - 16, rect ? rect.right - width : window.innerWidth - width - 20))}px`;
    popup.style.top = `${Math.max(16, Math.min(window.innerHeight - popup.offsetHeight - 16, rect ? rect.bottom + 12 : 100))}px`;
  }
  window.addEventListener('resize', positionProgress);
  window.addEventListener('scroll', positionProgress, { passive: true });

  function showProgress(cart) {
    if (cart.currency !== 'EUR' || !Number.isFinite(cart.total_price)) return;
    let popup = document.getElementById('sca-cart-mini-progress');
    if (!popup) {
      popup = document.createElement('div');
      popup.id = 'sca-cart-mini-progress';
      popup.setAttribute('role', 'status');
      popup.setAttribute('aria-live', 'polite');
      const parcel = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m12 3 9 5v9l-9 5-9-5V8l9-5Z M3 8l9 5 9-5 M12 13v9 M7.5 5.5l9 5v4"/></svg>';
      popup.innerHTML = `<div class="sca-mini-heading"><span class="sca-mini-icon">${parcel}</span><div><p class="sca-mini-text"></p></div></div><button type="button" aria-label="Fermer la notification">×</button><div class="sca-mini-track" aria-hidden="true"><span></span><i class="sca-mini-parcel">${parcel}</i></div><div class="sca-mini-labels" aria-hidden="true"><span>Votre panier</span><span>25 € · Livraison offerte</span></div><div class="sca-mini-stars" aria-hidden="true"><i>✦</i><i>✧</i><i>✦</i></div>`;
      popup.querySelector('button').addEventListener('click', () => { popup.hidden = true; clearTimeout(popupTimer); });
      document.body.appendChild(popup);
    }
    const giftProgress = window.scentalyaGift?.progress(cart);
    const remaining = giftProgress?.remaining ?? Math.max(0, 2500 - cart.total_price);
    const amount = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(remaining / 100);
    const message = popup.querySelector('.sca-mini-text');
    message.replaceChildren();
    if (remaining) {
      message.append('Plus que ');
      const strong = document.createElement('strong');
      strong.textContent = amount;
      message.append(strong, ' pour la livraison offerte');
    } else message.textContent = 'Livraison offerte ! ✨';
    if (giftProgress) message.textContent = giftProgress.message;
    popup.querySelector('.sca-mini-labels span:last-child').textContent = giftProgress?.label || '25 € · Livraison offerte';
    popup.classList.toggle('sca-mini-success', remaining === 0);
    popup.querySelector('.sca-mini-icon').innerHTML = remaining ? '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m12 3 9 5v9l-9 5-9-5V8l9-5Z M3 8l9 5 9-5 M12 13v9 M7.5 5.5l9 5v4"/></svg>' : '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m5 12 4 4L19 6"/></svg>';
    const percent = Math.min(100, Math.max(0, (giftProgress ? giftProgress.total * 100 / giftProgress.threshold : cart.total_price / 25)));
    const fill = popup.querySelector('.sca-mini-track span');
    const marker = popup.querySelector('.sca-mini-parcel');
    fill.style.width = `${percent}%`;
    marker.style.left = `clamp(12px, ${percent}%, calc(100% - 12px))`;
    popup.hidden = false;
    positionProgress();
    if (!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches && typeof fill.animate === 'function') {
      fill.animate([{ width: '0%' }, { width: `${percent}%` }], { duration: 600, easing: 'ease-out' });
      marker.animate([{ left: '12px' }, { left: marker.style.left }], { duration: 600, easing: 'ease-out' });
      if (!remaining) popup.querySelectorAll('.sca-mini-stars i').forEach((star, index) => {
        star.animate([{ opacity: 0, transform: 'translateY(8px) scale(.4)' }, { opacity: 1, transform: 'translateY(0) scale(1)', offset: .4 }, { opacity: 0, transform: 'translateY(-14px) scale(.7)' }], { duration: 1000, delay: index * 100, easing: 'ease-out' });
      });
    }
    clearTimeout(popupTimer);
    popupTimer = setTimeout(() => { popup.hidden = true; }, 4500);
  }

  function paint(count) {
    ensureBadges();
    document.querySelectorAll('.cart-count').forEach((element) => {
      const value = String(count);
      if (element.textContent.trim() !== value) element.textContent = value;
      element.hidden = count === 0;
      element.style.setProperty('display', count > 0 ? 'flex' : 'none', 'important');
      element.setAttribute('aria-live', 'polite');
      element.setAttribute('aria-atomic', 'true');
    });
  }

  async function refresh() {
    const currentRevision = revision;
    if (pending) return;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await originalFetch.call(window, `${root}cart.js`, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      let cart = await response.json();
      if (window.scentalyaGift) cart = await window.scentalyaGift.sync(cart);
      if (currentRevision !== revision || pending) return;
      if (!Number.isInteger(cart.item_count) || cart.item_count < 0) return;
      const increased = lastCount !== undefined && cart.item_count > lastCount;
      lastCount = cart.item_count;
      paint(lastCount);
      if (increased) bounce();
      if (announceAdd) { announceAdd = false; showProgress(cart); }
      window.scentalyaGift?.paint(cart);
    } catch (error) {
      console.warn('Scentalya : compteur du panier indisponible.', error);
    }
  }

  function schedule() {
    revision += 1;
    clearTimeout(timer);
    timer = setTimeout(refresh, 40);
  }

  window.fetch = function (...args) {
    if (!isCartMutation(args[0])) return originalFetch.apply(this, args);
    pending += 1;
    revision += 1;
    const finished = (response) => {
      if (response?.ok && args[1]?.headers?.['X-Scentalya-Gift'] !== '1' && /\/cart\/add(?:\.js)?(?:[?\/#]|$)/.test(String(args[0]?.url || args[0]))) announceAdd = true;
      pending -= 1;
      schedule();
    };
    try {
      return originalFetch.apply(this, args).then(
        (response) => { finished(response); return response; },
        (error) => { finished(); throw error; }
      );
    } catch (error) {
      finished();
      throw error;
    }
  };

  const trackedRequests = new WeakMap();
  XMLHttpRequest.prototype.open = function (method, url, ...args) {
    trackedRequests.set(this, { mutation: isCartMutation(url), add: /\/cart\/add(?:\.js)?(?:[?\/#]|$)/.test(String(url)) });
    return originalOpen.call(this, method, url, ...args);
  };
  XMLHttpRequest.prototype.send = function (...args) {
    const tracked = trackedRequests.get(this);
    if (!tracked?.mutation) return originalSend.apply(this, args);
    pending += 1;
    revision += 1;
    let completed = false;
    const finished = () => {
      if (completed) return;
      completed = true;
      if (tracked.add && this.status >= 200 && this.status < 300) announceAdd = true;
      this.removeEventListener('loadend', finished);
      pending -= 1;
      schedule();
    };
    this.addEventListener('loadend', finished, { once: true });
    try {
      return originalSend.apply(this, args);
    } catch (error) {
      finished();
      throw error;
    }
  };

  window.scentalyaCartCounter = { refresh: schedule };
  ['cart:updated', 'cart:refresh', 'cart:change', 'shopify:section:load'].forEach((name) => {
    document.addEventListener(name, schedule);
  });
  window.addEventListener('pageshow', schedule);
  window.addEventListener('focus', schedule);
  window.addEventListener('online', schedule);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') schedule();
  });

  function start() {
    const style = document.createElement('style');
    style.id = 'sca-cart-global-style';
    style.textContent = `
      #header .cart-count,#header-phone .cart-count,#phone-cart .cart-count{position:absolute!important;top:-10px!important;right:-9px!important;z-index:10000!important;min-width:21px!important;width:auto!important;height:21px!important;padding:0 4px!important;align-items:center!important;justify-content:center!important;border-radius:50px!important;background:#9b7c63!important;color:#fff!important;border:2px solid #eee6e0!important;font:600 11px/1 Exo,sans-serif!important;opacity:1!important;visibility:visible!important;pointer-events:none}
      #header .cart-count[hidden],#header-phone .cart-count[hidden],#phone-cart .cart-count[hidden]{display:none!important}
      #sca-cart-mini-progress{position:fixed;top:100px;right:20px;left:auto;z-index:1000000;width:min(385px,calc(100vw - 32px));background:#626b52;color:#eee6e0;border:1px solid #626b52;border-radius:12px;padding:17px 38px 17px 18px;box-shadow:0 6px 25px #342f2b22;font:13px/1.5 Exo,sans-serif}
      #sca-cart-mini-progress[hidden]{display:none!important}
      #sca-cart-mini-progress button{position:absolute;right:9px;top:8px;width:28px;height:28px;border:0;background:transparent;color:#eee6e0;font-size:22px;cursor:pointer}
      #sca-cart-mini-progress button:focus-visible{outline:2px solid #eee6e0}
      #sca-cart-mini-progress .sca-mini-heading{display:flex;align-items:center;gap:12px}
      #sca-cart-mini-progress p{margin:0;text-align:left;color:#eee6e0;line-height:1.5;letter-spacing:normal}
      #sca-cart-mini-progress .sca-mini-title{font-size:14px;font-weight:600;margin-bottom:4px}
      #sca-cart-mini-progress .sca-mini-text{font-size:12px}
      #sca-cart-mini-progress strong{font-weight:700;color:#faf7f4}
      #sca-cart-mini-progress svg{width:20px;height:20px;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round}
      #sca-cart-mini-progress .sca-mini-icon{display:grid;place-items:center;background:#eee6e022;border:1px solid #eee6e044;width:38px;height:38px;border-radius:50%;flex-shrink:0}
      #sca-cart-mini-progress .sca-mini-track{position:relative;height:8px;background:#eee6e033;border-radius:20px;margin-top:24px}
      #sca-cart-mini-progress .sca-mini-track>span{display:block;height:100%;background:#eee6e0;border-radius:20px;transition:width .3s ease}
      #sca-cart-mini-progress .sca-mini-parcel{position:absolute;top:50%;transform:translate(-50%,-50%);width:26px;height:26px;display:grid;place-items:center;background:#eee6e0;color:#626b52;border:2px solid #626b52;border-radius:50%;font-style:normal}
      #sca-cart-mini-progress .sca-mini-parcel svg{width:15px;height:15px}
      #sca-cart-mini-progress .sca-mini-labels{display:flex;justify-content:space-between;gap:8px;font-size:9px;opacity:.85;margin-top:12px}
      #sca-cart-mini-progress .sca-mini-stars{position:absolute;top:12px;right:38px;pointer-events:none}
      #sca-cart-mini-progress .sca-mini-stars i{display:inline-block;font-style:normal;opacity:0;padding:0 3px;color:#eee6e0}
      #sca-cart-mini-progress.sca-mini-success .sca-mini-icon{background:#eee6e0;color:#626b52}
      @media(prefers-reduced-motion:reduce){#sca-cart-mini-progress .sca-mini-track>span{transition:none}}

    `;
    document.head.appendChild(style);
    ensureBadges();
    new MutationObserver(() => {
      if (lastCount !== undefined) paint(lastCount);
    }).observe(document.body, { childList: true, subtree: true });
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

function initializeScentalyaApplication() {
  const logoutButton = document.getElementById('login-sublink-two');
  logoutButton?.addEventListener('click', (event) => {
    event.preventDefault();
    ['cart', 'cart_sig', 'cart_ts', 'cart_currency', 'cart_expiry'].forEach((name) => {
      document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
    });
    window.location.href = '/account/logout';
  });

  const form = document.getElementById('add-to-cart-form');
  const button = form?.querySelector('#add-to-cart-button, [type="submit"]');
  let adding = false;
  if (form && button) {
    form.addEventListener('submit', async (event) => {
      if (event.defaultPrevented) return;
      event.preventDefault();
      if (adding) return;
      adding = true;
      const wasDisabled = button.disabled;
      const wasBusy = button.getAttribute('aria-busy');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' }
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Impossible d’ajouter ce produit au panier.');
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item: data } }));
      } catch (error) {
        console.error('Scentalya : ajout au panier échoué.', error);
        window.alert(error.message || 'L’ajout au panier a échoué. Merci de réessayer.');
      } finally {
        adding = false;
        button.disabled = wasDisabled;
        if (wasBusy === null) button.removeAttribute('aria-busy');
        else button.setAttribute('aria-busy', wasBusy);
      }
    });
  }

  const header = document.querySelector('#header');
  const headerPhone = document.querySelector('#header-phone');
  function updateHeader() {
    [header, headerPhone].forEach((element) => element?.classList.toggle('header-scroll', window.scrollY > 30));
  }
  window.addEventListener('scroll', updateHeader, { passive: true });
  updateHeader();

  const inputBox = document.querySelector('.input-box');
  const searchIcon = document.querySelector('.icon');
  const spanIcon = document.querySelector('#delete-this');
  const closeIcon = document.querySelector('.close-icon');
  if (inputBox) {
    searchIcon?.addEventListener('click', () => {
      inputBox.classList.add('open');
      if (spanIcon) spanIcon.style.display = 'none';
    });
    closeIcon?.addEventListener('click', () => {
      inputBox.classList.remove('open');
      if (spanIcon) spanIcon.style.display = 'block';
    });
  }

  const toggleButton = document.querySelector('#toggle-menu-phone');
  const navPhone = document.querySelector('#nav-phone');
  const bgOverlay = document.querySelector('#bg-overlay');
  const crossIcon = document.querySelector('.cross-icon');
  function closeMenu() {
    navPhone?.classList.remove('active');
    bgOverlay?.classList.remove('active');
    document.body.style.overflow = 'auto';
  }
  if (navPhone && bgOverlay) {
    toggleButton?.addEventListener('click', () => {
      if (navPhone.classList.contains('active')) closeMenu();
      else {
        navPhone.classList.add('active');
        bgOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    });
    bgOverlay.addEventListener('click', closeMenu);
    crossIcon?.addEventListener('click', closeMenu);
    if (screen.height < 481) navPhone.classList.add('lil-phone');
  }

  function updateSlides() {
    document.querySelectorAll('.slide').forEach((slide) => slide.classList.toggle('overflow', window.innerWidth >= 1000));
  }
  window.addEventListener('load', updateSlides);
  window.addEventListener('resize', updateSlides);
  updateSlides();

  const toggleProfile = document.querySelector('#login');
  const dropdown = document.querySelector('.login-dropdown');
  if (toggleProfile && dropdown) toggleProfile.addEventListener('click', () => dropdown.classList.toggle('open'));
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeScentalyaApplication, { once: true });
else initializeScentalyaApplication();

function faq(element) {
  element.parentNode.querySelector('.reponse')?.classList.toggle('show');
  element.querySelector('.faqArrow')?.classList.toggle('rotateFaq');
}

